import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PdfService {

constructor(private https: HttpClient) { }

fetchPdf(url:string): Observable<Blob>{
  return this.https.get(url,{responseType:'blob'});
}

createBlobUrl (blob:Blob):string {
  return URL.createObjectURL(blob);
}

}
